import script from "./ReviewDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&setup=true&lang=js"

import "./ReviewDetail.vue?vue&type=style&index=0&id=277879fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277879fd"]])

export default __exports__